import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getNumberOfTicketsSoldOfEvent, getEventById } from "ticketino-api-client";
import { Calendar } from "react-calendar";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import { DateTimeManager } from '../Common/DateTimeManager.js';
import imgIconProgress1 from '../img/icon-progress1.svg';
import imgIconProgressGrey from '../img/icon-progress-grey.svg';
import imgAabramovicGuidedTour from "../img/abramovic-guided-tour.jpg";
import imgIconRightGrey from '../img/icon-right-grey.svg';
import imgIconLeftGrey from '../img/icon-left-grey.svg';

import "../css/style.css";
import "../css/calendar.css";
import "../css/ticketing.css";

const Step15_Tours_Abramovic = () => {
    const [posId, setPosId] = useState(null);

    const [order, setOrder] = useState({});

    const [eventGroupTours, setEventGroupTours] = useState({});
    const [events, setEvents] = useState([]);

    const [loading, setLoading] = useState(true);
    const [selectedPage, setSelectedPage] = useState(0);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        case ("it" || "IT"):
            languageId = 4;
            break;
        default:
            languageId = 0;
            break;
    }

    const [selectedLanguage, setSelectedLanguage] = useState(languageId);
    const [selectedMonth, setSelectedMonth] = useState(10);//from october we should change to new Date().getMonth() + 1

    let navigate = useNavigate();
    let baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    const [resources, setResources] = useState({});

    useEffect(() => {

        setLoading(true);

        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await sessionStorage.setItem("token", res.data);
                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        let currentOrderId = sessionStorage.getItem("OrderId");

        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);

                if (currentOrderId > 0) {
                    loadOrder(currentOrderId)
                } else {
                    startOrder(res.data.posId);
                }

                const eventGroups = {
                    1: res.data.eventGroupIdTourDE,
                    2: res.data.eventGroupIdTourFR,
                    3: res.data.eventGroupIdTourEN,
                };

                setEventGroupTours(eventGroups);

                setPosId(res.data.posId)

            } catch (error) {
                console.error(error);
            }
        };

        loadToken();
        setLoading(false);
    }, []);


    useEffect(() => {

        setLoading(true);

        const requestResources = async () => {
            try {
                const res = await axios.get(`form/resources/${language}`);
                setResources(res.data?.translation);
            } catch (error) {
                console.error(error);
            }
        };

        requestResources();
        setLoading(false);
    }, [language]);

    useEffect(() => {

        const eventGroupId = eventGroupTours[selectedLanguage];

        if (eventGroupId == null) {
            setEvents([]);
            return;
        }
        const requestEvents = async (eventGroupId) => {

            const totalNumberOfEventsResponse = await axios.get(`${baseUrl}/EventGroup/${eventGroupId}/Events/Count`);
            const totalNumberOfEvents = totalNumberOfEventsResponse.data;
            const eventBatchSize = 100;
            let events = [];

            for (let i = 0; i <= totalNumberOfEvents; i += eventBatchSize) {
                const eventGroupEventsResponse = await axios.get(`${baseUrl}/EventGroup/Events?eventGroupId=${eventGroupId}&languageCode=${language}&numberToTake=${eventBatchSize}&numberToSkip=${i}`);
                events = events.concat(eventGroupEventsResponse.data?.events);
            }

            await Promise.all(events.map(async (event) => {

                const eventApimodel = await getEventById(event.id);
                const soldTicketOfEvent = await getNumberOfTicketsSoldOfEvent(event.id);

                event.end = eventApimodel.end;
                event.ticketsFree = eventApimodel.maxTickets - soldTicketOfEvent;

                return event;
            }))

            setEvents(events);
        };



        requestEvents(eventGroupId);

    }, [selectedLanguage, eventGroupTours]);

    const startOrder = async (posId) => {

        const order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            pointOfSaleId: posId ?? 6585,
            abbreviation: "",
            paymentType: 1,
        };

        try {
            const res = await axios.post(`${baseUrl}/ShopBasket/Order`, order);

            await sessionStorage.setItem("OrderId", res.data.id);

            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    };

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            if (updatedOrder != null && updatedOrder.tickets != null) {

                let ticketTypeIdsToRemove = updatedOrder.tickets
                    .map(ticket => ticket.id);

                // DELETE request to remove tickets
                await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                    data: { TicketsToRemove: ticketTypeIdsToRemove }
                });

                updatedOrder.tickets = [];
            }

            setOrder(updatedOrder);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                const newOrder = await startOrder(posId);
                return newOrder;
            }
        }
    }

    const selectLanguage = async (languageId) => {
        setSelectedLanguage(parseInt(languageId));
    }

    const selectMonth = async (month) => {
        setSelectedMonth(parseInt(month));
    }

    const buyTourTickets = async (event) => {

        sessionStorage.removeItem("BeginTimeAbramovic");
        sessionStorage.removeItem("EndTimeAbramovic");

        navigate(`/${language}/marina-abramovic-tickets/${event.id}`);
    }

    const setPage = (e, pageIndex) => {
        e.preventDefault();
        setSelectedPage(pageIndex);
    }

    const getDayOfTheDate = (date) => {

        let dayOfWeek = date.getDay();

        if (dayOfWeek === 0) {
            return resources.Sunday;
        }
        else if (dayOfWeek === 1) {

            return resources.Monday;
        } else if (dayOfWeek === 2) {

            return resources.Tuesday;
        } else if (dayOfWeek === 3) {

            return resources.Wednesday;
        } else if (dayOfWeek === 4) {

            return resources.Thursday;
        } else if (dayOfWeek === 5) {

            return resources.Friday;
        } else {
            return resources.Saturday;
        }
    }


    const mapEvents = () => {

        const pageSize = 4;

        const eventsToMap = events
            //only take the events from the selected month
            .filter(event => new Date(event.start).getMonth() + 1 === selectedMonth)
            //check the position of the page to determine the events to show
            .slice(selectedPage * pageSize, (selectedPage + 1) * pageSize);

        var eventsInTheSelectedMonth = events
            //only take the events from the selected month
            .filter(event => new Date(event.start).getMonth() + 1 === selectedMonth);


        const lastPage = Math.ceil(eventsInTheSelectedMonth.length / pageSize);


        let eventsInCurrentMonth = events?.filter(event => new Date(event.start).getMonth() + 1 === selectedMonth) ?? 0;

        return (
            <>
                {eventsToMap?.length > 0 && (
                    <div className="container">
                        {/* Create two rows */}
                        {[0, 2].map(rowIndex => (
                            <div className="row" key={rowIndex}>
                                {/* Map the first two events to the columns of the first row */}
                                {eventsToMap.slice(rowIndex, rowIndex + 2).map((event, colIndex) => {
                                    const date = new Date(event.start);
                                    const endDate = new Date(event.end);
                                    return (
                                        <div className="col-md-6 col-12" key={event.id}>
                                            <div className="row">
                                                <div className="col-12 mt-3">
                                                    <div className="row">
                                                        <div className="col-12 mt-3 d-flex align-items-center">
                                                            <p className="text-22-27 black-color font-900">{`${getDayOfTheDate(date)}`}</p>
                                                            <p className="text-40-45 black-color font-900 padding-left-10">{`${date.getDate()}.${date.getMonth() + 1}`}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <p className="text-22-27  font-900 black-color">{`${("0" + date.getHours()).slice(-2)}:${("0" + date.getMinutes()).slice(-2)}`}-{`${("0" + endDate.getHours()).slice(-2)}:${("0" + endDate.getMinutes()).slice(-2)}`}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-6 col-md-4">
                                                    <p className="text-21-25 black-color d-flex align-items-end">{event.ticketsFree} {resources?.PlacesFree}</p>
                                                </div>
                                                <div className="col-6 col-md-8">
                                                    <button className="btn custom-button pl-5" onClick={() => buyTourTickets(event)}>
                                                        <svg width="30" height="25" viewBox="0 0 39 34" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="svg-ticket">
                                                            <path fill="evenodd" fillRule="evenodd" clip-rule="evenodd" d="M0.340034 17.4648C0.383166 17.4864 28.3505 23.097 28.3972 23.097C28.6417 23.0863 28.8789 22.9353 28.9256 22.6981L29.0766 21.9433C29.1233 21.7025 28.9651 21.4724 28.7423 21.3682C27.9947 21.0159 27.5525 20.1893 27.7215 19.341C27.8904 18.4927 28.6201 17.8997 29.4468 17.8637C29.6912 17.8529 29.9284 17.702 29.9751 17.4648L30.0866 16.9112L30.1261 16.7064C30.1729 16.4655 30.0147 16.2355 29.7919 16.1313C29.0442 15.779 28.6021 14.9523 28.7711 14.1041C28.94 13.2558 29.6697 12.6628 30.4964 12.6268C30.7408 12.616 30.978 12.4651 31.0247 12.2279L31.1757 11.473C31.2224 11.2322 31.0642 11.0022 30.8414 10.898C30.0938 10.5457 29.6517 9.71902 29.8206 8.87076C29.9896 8.0225 30.7192 7.42944 31.5459 7.3935C31.7903 7.38272 32.0275 7.23176 32.0743 6.99453L32.2432 6.15706C32.2899 5.91624 32.1353 5.68261 31.8945 5.63588C31.8945 5.63588 3.79061 0 3.76186 0C3.55339 0 3.37008 0.147367 3.32694 0.355837L3.15801 1.19331C3.11128 1.43413 3.26943 1.66417 3.49228 1.7684C4.2399 2.12064 4.682 2.94734 4.51307 3.79559C4.34413 4.64385 3.61449 5.23691 2.7878 5.27286C2.54335 5.28364 2.30616 5.4346 2.25943 5.67182L2.10847 6.42663C2.06175 6.66745 2.2199 6.89749 2.44274 7.00172C3.19036 7.35396 3.6325 8.18066 3.46353 9.02891C3.29459 9.87717 2.56495 10.4702 1.73826 10.5062C1.49384 10.517 1.25662 10.6679 1.20989 10.9051L1.05893 11.6599C1.01221 11.9008 1.17039 12.1308 1.3932 12.235C2.14086 12.5873 2.58296 13.414 2.41399 14.2622C2.24506 15.1105 1.51541 15.7036 0.688718 15.7395C0.444305 15.7503 0.20708 15.9013 0.160354 16.1385L0.00939317 16.8933C-0.0409631 17.1341 0.117151 17.3606 0.340034 17.4648ZM18.2482 16.8646L21.1173 17.4494L16.3421 11.0142L22.1485 7.61997L19.4053 7.06091L14.6995 9.80457L12.1677 9.2886L12.8905 5.74221L10.8119 5.31861L8.84924 14.9491L10.9278 15.3727L11.8036 11.0752L14.33 11.5901L18.2482 16.8646ZM3.88854 20.93C3.82936 20.8864 3.77694 20.8357 3.73415 20.7808L30.2022 26.0238L32.0848 16.5204L37.8675 19.1999C38.105 19.3085 38.2252 19.5593 38.1395 19.7603L37.8348 20.4578C37.7496 20.6557 37.4843 20.7238 37.2339 20.6654C36.3872 20.4671 35.5508 20.7912 35.2444 21.4983C34.9379 22.2053 35.2565 23.0633 35.9612 23.5846C36.1714 23.7393 36.2958 23.9878 36.2101 24.1889L35.9367 24.8179C35.8516 25.0158 35.5863 25.0839 35.3359 25.0255C34.4892 24.8272 33.6528 25.1513 33.3463 25.8584C33.0398 26.5654 33.3585 27.4234 34.0632 27.9447C34.2734 28.0994 34.3978 28.3479 34.3121 28.549L34.2393 28.7201L34.0381 29.1812C33.9529 29.3791 33.6877 29.4472 33.4373 29.3887C32.5905 29.1905 31.7541 29.5146 31.4477 30.2216C31.1412 30.9287 31.4599 31.7867 32.1646 32.308C32.3748 32.4627 32.4992 32.7112 32.4134 32.9123L32.1401 33.5413C32.0549 33.7392 31.7897 33.8073 31.5393 33.7488C31.4917 33.7358 3.929 20.9612 3.88854 20.93Z"></path>
                                                        </svg>
                                                        <span>{resources?.Tickets}</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="row mt-1">
                                                <div className="col-12">
                                                    <div className="mt-3 grey-line" >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ))}
                    </div>
                )}

                {eventsInCurrentMonth?.length > pageSize &&
                    <div className="mt-5 d-flex justify-content-center align-items-center">
                        <ul className="pagination">
                            {selectedPage > 0 && <li className="padding-top-5">
                                <a href="#" aria-label="Previous" onClick={(e) => { setPage(e, selectedPage - 1) }} style={{ backgroundColor: 'transparent', border: 'none' }}>
                                    <img src={imgIconLeftGrey} alt="Previous" className="paging-arrow-image" />
                                </a>
                            </li>}
                            <li ><a className={selectedPage === 0 ? "selected-paging-number" : "un-selected-paging-number"} href="#" onClick={(e) => { setPage(e, 0) }} >1</a></li>
                            <li className="padding-bottom-15"><a className={selectedPage === 1 ? "selected-paging-number" : "un-selected-paging-number"} href="#" onClick={(e) => { setPage(e, 1) }} >2</a></li>
                            {lastPage > 2 &&
                                <li ><a className={selectedPage === lastPage - 1 ? "selected-paging-number" : "un-selected-paging-number"} href="#" onClick={(e) => { setPage(e, lastPage - 1) }}>{lastPage}</a></li>}
                            {selectedPage < lastPage - 1 && <li className="padding-top-5">
                                <a href="#" aria-label="Next" onClick={(e) => { setPage(e, selectedPage + 1) }} style={{ backgroundColor: 'transparent', border: 'none' }}>
                                    <img src={imgIconRightGrey} alt="Next" className="paging-arrow-image" />
                                </a>
                            </li>}
                        </ul>
                    </div>}
            </>
        );
    };

    const mapMonthSelector = () => {

        const date = new Date();

        return (
            <>
                <select
                    className="form-control form-select  text-20-24"
                    name="month"
                    value={selectedMonth}
                    onChange={(e) => { selectMonth(e.target.value); }}>
                    {date.getMonth() < 10 && date.getFullYear() === 2024 && <option value={10}>{resources?.October}</option>}
                    {date.getMonth() < 11 && date.getFullYear() === 2024 && <option value={11}>{resources?.November}</option>}
                    {date.getMonth() < 12 && date.getFullYear() === 2024 && <option value={12}>{resources?.December}</option>}
                    {((date.getMonth() < 1 && date.getFullYear() === 2025) || date.getFullYear() === 2024) && <option value={1}>{resources?.January}</option>}
                    {((date.getMonth() < 2 && date.getFullYear() === 2025) || date.getFullYear() === 2024) && <option value={2}>{resources?.February}</option>}
                </select>
            </>
        );
    };

    return (
        <div className="d-flex flex-column min-vh-100">
            {loading && <Loading alignment="center" color="#d3d3d3" bgColor="transparent" position="fixed" top="300px" />}
            <>
                <div>
                    <Navbar numberOfTickets={order?.tickets?.length ?? 0} isShoppingCartVisible={true} pagePath="marina-abramovic" />
                    <main className="flex-fill">
                        {resources && (
                            <div>
                                <div className="container page-wrapper">
                                    <div>
                                        <div className="progress-container">
                                            <div className="progress-step active">
                                                <div>
                                                    <div className="image">
                                                        <img src={imgIconProgress1} alt="Step 1" />
                                                    </div>
                                                    <div className="step-number text-wrap visible-desktop">{resources?.DateAndTime}</div>
                                                </div>
                                                <div className="line"></div>
                                            </div>

                                            <div className="progress-step completed">
                                                <div>
                                                    <div className="image">
                                                        <img src={imgIconProgressGrey} alt=" Step 2" />
                                                    </div>
                                                    <div className="step-number text-wrap visible-desktop">{resources?.TicketSelection}</div>
                                                </div>
                                                <div className="line"></div>
                                            </div>

                                            <div className="progress-step">
                                                <div>
                                                    <div className="image">
                                                        <img src={imgIconProgressGrey} alt="Step 3" />
                                                    </div>
                                                    <div className="step-number text-wrap visible-desktop">{resources?.SummaryAndContact}</div>
                                                </div>
                                                <div className="line"></div>
                                            </div>

                                            <div className="progress-step">
                                                <div>
                                                    <div className="image">
                                                        <img src={imgIconProgressGrey} alt="Step 4" />
                                                    </div>
                                                    <div className="step-number text-wrap visible-desktop">{resources?.PaymentAndDelivery}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-5 sticky-wrapper">
                                            <div className="col-md-8">
                                                <p className="text-50-55 black-color font-500">{resources?.GuidedTours}</p>
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <img className="guided-tour-image"
                                                    src={imgAabramovicGuidedTour}
                                                    alt="Guided tour"
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-5">
                                            <div className="col-md-12">
                                                <p className="text-20-22 black-color">25.10.2024-16.02.2025</p>
                                                <p className="text-40-45 font-900 black-color text-uppercase">{resources?.MarinaAbramovic}</p>
                                                <p className="text-16-18 dark-grey-color"
                                                    dangerouslySetInnerHTML={{ __html: resources?.TourDescr }}
                                                ></p> </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-container-blue">
                                    <div className="container page-wrapper">
                                        <div className="row pt-3">
                                            <div className="col-md-3 col-6 text-20-24">
                                                {mapMonthSelector()}
                                            </div>
                                            <div className="col-md-3 col-6">
                                                <div>
                                                    <select
                                                        className="form-control form-select text-20-24"
                                                        name="language"
                                                        value={selectedLanguage}
                                                        onChange={(e) => { selectLanguage(e.target.value); }}>
                                                        <option value={1}>{resources?.German}</option>
                                                        <option value={2}>{resources?.French}</option>
                                                        <option value={3}>{resources?.English}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row pt-3">
                                            {events.length > 0 && mapEvents()}
                                        </div>
                                        <div className="row mt-5 mb-4">
                                            <div className="col-6 d-flex justify-content-start align-items-center">
                                                <button className="btn transperant-grey-button" onClick={() => navigate(-1)}>
                                                    {resources?._Back}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <Footer />
                                </div>
                            </div>
                        )}
                    </main>
                </div>
            </>
        </div >
    );
};

export default Step15_Tours_Abramovic;